// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 1C5.92487 1 1 5.92487 1 12C1 14.6615 1.94632 17.1038 3.51936 19.006L1.30049 23H12C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM13 11.5858L16.4142 15L15 16.4142L11 12.4142V5.5H13V11.5858Z"}}]};

const ChatBubbleHistoryFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chat-bubble-history-filled',
    ref,
    icon: element,
  },
));

ChatBubbleHistoryFilledIcon.displayName = 'ChatBubbleHistoryFilledIcon';

export default ChatBubbleHistoryFilledIcon;
